import {
    webpushSecondChanceAllow,
    webpushSecondChanceHeader,
    webpushSecondChanceBody,
} from './SecondChanceCallout.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47650 */
import { observer } from 'mobx-react-lite';
import { ButtonType, IButtonProps } from 'office-ui-fabric-react/lib/Button';
import { DirectionalHint } from 'office-ui-fabric-react/lib/common/DirectionalHint';
import { TeachingBubble } from 'office-ui-fabric-react/lib/TeachingBubble';
import { completeWebPushSecondChanceCallout } from '../actions/secondChanceCalloutActions';
import * as React from 'react';

export interface SecondChanceProps {
    target: () => HTMLElement;
}

export const SecondChanceCallout = observer(function SecondChanceCallout(props: SecondChanceProps) {
    let gotItButtonProps: IButtonProps = {
        buttonType: ButtonType.primary,
        children: loc(webpushSecondChanceAllow),
        onClick: () => completeWebPushSecondChanceCallout(true),
    };

    return (
        <TeachingBubble
            calloutProps={{
                beakWidth: 15,
                directionalHint: DirectionalHint.bottomAutoEdge,
                preventDismissOnLostFocus: true,
                preventDismissOnScroll: true,
            }}
            targetElement={props.target()}
            hasCloseIcon={true}
            onDismiss={() => completeWebPushSecondChanceCallout(false)}
            hasSmallHeadline={true}
            isWide={true}
            headline={loc(webpushSecondChanceHeader)}
            primaryButtonProps={gotItButtonProps}>
            {loc(webpushSecondChanceBody)}
        </TeachingBubble>
    );
});
